// import '@babel/polyfill'
import 'intersection-observer'
// import 'dom4';
import Highway from '@dogstudio/highway/src/highway'

import Home from './Home'
import About from './About'
import ListingCreas from './ListingCreas'
import SingleCrea from './SingleCrea'

import MotionTime from './modules/MotionTime'
import InstagramIcon from './modules/InstagramIcon'

import TransitionAbout from './transitions/TransitionAbout'
import TransitionHome from './transitions/TransitionHome'
import TransitionWorks from './transitions/TransitionWorks'
import TransitionSingleCrea from './transitions/TransitionSingleCrea'

import Cursor from './modules/Cursor'
import Breakpoints from './modules/Breakpoints'

import gsap from 'gsap'

import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import Loader from './modules/Loader'
import Footer from './modules/Footer'

import '../scss/_general.scss'
import Page404 from './404'
gsap.registerPlugin(ScrollToPlugin)

// Loader
const globalLoader = new Loader()

// Responsive en vrac pour l'instant
const clonedMenu = document.querySelector('.sidebar__menu').cloneNode(true)
clonedMenu.classList.remove('sidebar__menu')
clonedMenu.classList.add('sidebar__menu-responsive')
clonedMenu.querySelector('.sidebar__menu-special').remove()
document.querySelector('.header__sidebar').appendChild(clonedMenu)

const responsiveMenu = document.querySelector('.sidebar__menu-responsive')
const responsiveMenuItems = responsiveMenu.querySelectorAll(
    '.sidebar__menu-item'
)
const responsiveMenuTrigger = document.querySelector(
    '.sidebar__menu-responsive-trigger'
)
const responsiveMenuClose = responsiveMenu.querySelector(
    '.sidebar__menu-responsive-closeBtn'
)

let responsiveMenuTimelineIn = new gsap.timeline({
    paused: true,
})

let responsiveMenuTimelineOut = new gsap.timeline({
    paused: true,
})

responsiveMenuTimelineIn
    .fromTo(
        responsiveMenu,
        {
            opacity: 0,
        },
        {
            duration: 0.2,
            opacity: 1,
            ease: 'expo.easeOut',
        }
    )
    .fromTo(
        responsiveMenuItems,
        {
            opacity: 0,
            y: 20,
        },
        {
            y: 0,
            duration: 0.2,
            opacity: 1,
            stagger: 0.05,
            ease: 'expo.easeOut',
        }
    )

responsiveMenuTimelineOut
    .to(responsiveMenuItems, {
        y: -20,
        duration: 0.2,
        opacity: 0,
        stagger: 0.05,
        ease: 'expo.easeOut',
    })
    .to(responsiveMenu, {
        duration: 0.2,
        opacity: 0,
        ease: 'expo.easeOut',
    })

responsiveMenuTrigger.addEventListener('click', () => {
    responsiveMenuTimelineIn.play(0)
    responsiveMenu.classList.add('active')
})

responsiveMenuClose.addEventListener('click', () => {
    responsiveMenuTimelineOut.play(0)
    responsiveMenu.classList.remove('active')
})

responsiveMenuItems.forEach((item) => {
    item.addEventListener('click', () => {
        gsap.to(responsiveMenu, {
            duration: 0.1,
            opacity: 0,
        })
        responsiveMenu.classList.remove('active')
    })
})

// Highway init
document.body.addEventListener('loaderFinished', () => {
    const H = new Highway.Core({
        transitions: {
            default: TransitionAbout,
            contextual: {
                about: TransitionAbout,
                home: TransitionHome,
                works: TransitionWorks,
                caseStudy: TransitionSingleCrea,
            },
        },
        renderers: {
            home: Home,
            about: About,
            listingCreas: ListingCreas,
            singleCrea: SingleCrea,
            page404: Page404,
        },
    })

    // Headers links active class and micro interactions
    const headerLinks = document.querySelectorAll('.header--default li')

    H.on('NAVIGATE_END', ({ to, from, trigger, location }) => {
        // Cursor stuff
        globalCursor.linksSetup()

        window.scrollTo(0, 0)
        if (window.innerWidth > Breakpoints.tablet) {
            if (headerLinks && location.pathname !== '/') {
                gsap.to(headerLinks, {
                    duration: 0.2,
                    ease: 'expo.easeOut',
                    x: 0,
                    opacity: 1,
                    stagger: 0.05,
                    onComplete: () => {
                        // if (location.pathname.includes('/works/')) {
                        //     document.querySelector('.sidebar__menu-responsive sidebar__menu-item-link[data-transition="works"]').parentNode.classList.add('current-menu-item');
                        //     document.querySelector('.sidebar__menu-item-link[data-transition="works"]').parentNode.classList.add('current-menu-item');
                        // } else {
                        //     trigger.parentNode.classList.add('current-menu-item');
                        //     trigger.parentNode.classList.add('current-menu-item');
                        // }
                    },
                })
            }
        } else {
            if (location.pathname !== '/') {
                let responsiveMenuTrigger = document.querySelector(
                    '.sidebar__menu-responsive-trigger'
                )
                let responsiveMenuTriggerBranches = responsiveMenuTrigger.querySelectorAll(
                    'span'
                )

                gsap.fromTo(
                    responsiveMenuTriggerBranches,
                    {
                        x: 10,
                        opacity: 0,
                    },
                    {
                        duration: 0.1,
                        stagger: 0.05,
                        x: 0,
                        opacity: 1,
                        ease: 'expo.easeOut',
                    }
                )
            }
        }
    })

    H.on('NAVIGATE_OUT', ({ to, from, trigger, location }) => {
        // Cursor stuff
        globalCursor.removeCurrentLinks()
        let cursor = document.querySelector('.cursor')
        cursor.classList.remove('hinting')
        cursor.classList.remove('hovering')

        // Menu animation
        let currentMenuItemResponsive = document.querySelector(
            '.header--default .sidebar__menu-responsive li.current-menu-item'
        )
        let currentMenuItem = document.querySelector(
            '.header--default li.current-menu-item'
        )

        if (currentMenuItem) {
            currentMenuItem.classList.remove('current-menu-item')
            currentMenuItemResponsive.classList.remove('current-menu-item')
        }

        if (window.innerWidth > Breakpoints.tablet) {
            if (headerLinks) {
                gsap.to(headerLinks, {
                    duration: 0.1,
                    ease: 'expo.easeOut',
                    x: 10,
                    opacity: 0,
                    stagger: 0.05,
                })
            }
        } else {
            let responsiveMenuTrigger = document.querySelector(
                '.sidebar__menu-responsive-trigger'
            )
            let responsiveMenuTriggerBranches = responsiveMenuTrigger.querySelectorAll(
                'span'
            )

            gsap.to(responsiveMenuTriggerBranches, {
                duration: 0.1,
                stagger: 0.05,
                x: 10,
                opacity: 0,
                ease: 'expo.easeOut',
            })
        }
    })

    H.on('NAVIGATE_IN', ({ to }) => {
        document.body.classList = to.page.body.classList

        if (!to.page.body.classList.contains('home')) {
            const headerLogo = document.querySelector('.header__logo')

            gsap.to(headerLogo, {
                duration: 0.4,
                ease: 'expo.easeOut',
                opacity: 1,
            })
        }

        // Handling footer UX
        const footerInstance = new Footer()
        footerInstance.initCursor()

        // Location menu switcher thing
        if (location.pathname.includes('works')) {
            document
                .querySelector(
                    '.sidebar__menu-responsive .sidebar__menu-item-link[data-transition="works"]'
                )
                .parentNode.classList.add('current-menu-item')
            document
                .querySelector(
                    '.sidebar__menu-item-link[data-transition="works"]'
                )
                .parentNode.classList.add('current-menu-item')
        }

        if (location.pathname.includes('about')) {
            document
                .querySelector(
                    '.sidebar__menu-responsive .sidebar__menu-item-link[data-transition="about"]'
                )
                .parentNode.classList.add('current-menu-item')
            document
                .querySelector(
                    '.sidebar__menu-item-link[data-transition="about"]'
                )
                .parentNode.classList.add('current-menu-item')
        }

        if (location.pathname == '/') {
            document
                .querySelector(
                    '.sidebar__menu-responsive .sidebar__menu-item-link[data-transition="home"]'
                )
                .parentNode.classList.add('current-menu-item')
            document
                .querySelector(
                    '.sidebar__menu-item-link[data-transition="home"]'
                )
                .parentNode.classList.add('current-menu-item')
        }
    })
})

// setting up Motion Time
const motionTime = new MotionTime()
motionTime.init()

const allMotionTimeItems = document.querySelectorAll(
    '.motionTime__items-list li'
)

allMotionTimeItems.forEach((item) => {
    item.addEventListener('click', () => {
        let currentlyActive = document.querySelector(
            '.motionTime__items-list li.active'
        )
        if (currentlyActive) {
            currentlyActive.classList.remove('active')
        }

        item.classList.add('active')
    })

    item.addEventListener('mouseover', () => {
        let currentlyActive = document.querySelector(
            '.motionTime__items-list li.active'
        )
        if (currentlyActive) {
            currentlyActive.classList.remove('active')
        }

        item.classList.add('active')
    })

    item.addEventListener('mouseleave', () => {})
})

const globalCursor = new Cursor()
globalCursor.init()

const footerInstance = new Footer()
footerInstance.initCursor()

// Set link active on page load for case studies
if (location.pathname.includes('/works/')) {
    document
        .querySelector(
            '.sidebar__menu-responsive .sidebar__menu-item-link[data-transition="works"]'
        )
        .parentNode.classList.add('current-menu-item')
    document
        .querySelector('.sidebar__menu-item-link[data-transition="works"]')
        .parentNode.classList.add('current-menu-item')
}

// Instagram logo animation preload
const instagramIconInstance = new InstagramIcon()
